import { PublishMockInvoiceApiFactory } from "../../../lusca-search-api/LuscaSearchApiFactory";
import { Stage } from "../../../lusca-search-api/generated-src";

export const usePublishMockInvoice = () => {
  const publishMockInvoice = async (
    paymentId: string,
    paymentDate: string,
    stage: Stage
  ) => {
    const publishMockInvoiceApi = PublishMockInvoiceApiFactory();
    return await publishMockInvoiceApi.publishMockAcadiaInvoice(stage, {
      paymentId: paymentId,
      paymentDate: paymentDate,
    });
  };

  return { publishMockInvoice };
};
